import React, { useState, useEffect } from 'react';
import './AboutUsBanner.css';
import AboutUsBannervideo from '../../../assets/images/career/careerheader.mp4';

const TEXT_ARRAY = [
  'Accelerate Digital Transformation',
  'Innovative Solutions for a Better Tomorrow',
  'Empowering Your Business',
  'Driving Excellence in Every Project',
];

const AboutUsBanner = () => {
  const [textIndex, setTextIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setTextIndex((prevIndex) => (prevIndex + 1) % TEXT_ARRAY.length);
    }, 5000); // Change text every 5 seconds

    return () => clearInterval(interval);
  }, []);

  return (
    
    <div className="banner-container">
      <div className="video-banner">
        <video autoPlay loop muted>
          <source src={AboutUsBannervideo} type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
   
      <div className="text-overlay">
        <h1>{TEXT_ARRAY[textIndex]}</h1>
      </div>
    </div>
  );
};

export default AboutUsBanner;
